import type { Property } from "@/features/survey/types/survey.property.types";

/**
 * Check if latitude and longitude coordinates are invalid
 * Valid latitude: -90 to 90 (excluding 0)
 * Valid longitude: -180 to 180 (excluding 0)
 */
export const isInvalidCoordinate = (lat: string, lng: string): boolean => {
  const latNum = parseFloat(lat);
  const lngNum = parseFloat(lng);

  const isLatInvalid =
    isNaN(latNum) ||
    latNum < -90 ||
    latNum > 90 ||
    lat.trim() === "" ||
    latNum === 0;

  const isLngInvalid =
    isNaN(lngNum) ||
    lngNum < -180 ||
    lngNum > 180 ||
    lng.trim() === "" ||
    lngNum === 0;

  return isLatInvalid || isLngInvalid;
};

/**
 * Filter properties that have invalid latitude/longitude coordinates
 */
export const getPropertiesWithInvalidCoordinates = (
  properties: Property[],
): Property[] => {
  return properties.filter((property) =>
    isInvalidCoordinate(property.latitude, property.longitude),
  );
};
